
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'filterTab'
})

@Injectable()
export class FilterTabSearch implements PipeTransform {

  transform(items: any[], term: string): any {
    if (term) {
      return items.filter(item => {
        return Object.keys(item).some(
          k => {
            if (item[k] != null && item[k] !== undefined && typeof item[k] === 'string') {
             
              return item[k].toLowerCase().indexOf(term.toLowerCase()) !== -1 ;
            }
          }
        );
      });
    }
    return items;
  }
}
